import React from 'react';
import { TextField } from '@material-ui/core';

import { formatPhoneNumber } from '../../Entities/util';


class InputPhoneNumberField extends React.Component {
  caretPosition = 0;


  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
  }


  componentDidUpdate() {
    if (this.inputRef.current) {
      this.inputRef.current.selectionStart = this.caretPosition;
      this.inputRef.current.selectionEnd = this.caretPosition;

      this.caretPosition = 0;
    }
  }


  handleChangeEvent = event => {
    if (event.type === 'keydown') {
      if (event.which === 8/* Backspace */) {
        event.preventDefault();

        const selectionStart = event.target.selectionStart;
        const selectionEnd = event.target.selectionEnd;
        let value = event.target.value;

        let leadingSlicePosition;
        let trailingSlicePosition;

        if (selectionStart !== selectionEnd) {
          leadingSlicePosition = selectionStart;
          trailingSlicePosition = selectionEnd;
        }
        else {
          trailingSlicePosition = leadingSlicePosition = selectionEnd;
          if (trailingSlicePosition > 1) {
            let characterAtLeadingSlicePosition;
            do {
              leadingSlicePosition--;
              characterAtLeadingSlicePosition = value.substring(leadingSlicePosition, (leadingSlicePosition + 1));
            }
            while (characterAtLeadingSlicePosition.replace(/\D/g, '') === '')
          }
        }

        this.caretPosition = (trailingSlicePosition - (trailingSlicePosition - leadingSlicePosition));

        const newvalue = `${value.substring(0, leadingSlicePosition)}` +
          `${value.substring(trailingSlicePosition)}`;
        const parsedValue = newvalue.replace(/\D/g, '');

        this.props.onChange(parsedValue || null);
      }
    }

    else if (event.type === 'change') {
      const newValue = event.target.value;
      const parsedValue = newValue.replace(/\D/g, '');

      let newCaretPosition = event.target.selectionEnd;
      if (newCaretPosition === 1) newCaretPosition = newCaretPosition + 1;
      if (newCaretPosition === 4) newCaretPosition = newCaretPosition + 2;
      if (newCaretPosition === 9) newCaretPosition = newCaretPosition + 1;
      this.caretPosition = newCaretPosition;

      this.props.onChange(parsedValue || null);
    }
  }


  render() {
    const {
      inputId = '',
      value = null,
      editMode = false,
      disabledMode = false
    } = this.props;

    const nullSafeFormattedValue = (value === null) ? '' : formatPhoneNumber(value);

    return (
      <div className="parkchirp--input-phone-number-field">
        {(editMode === true) &&
          <TextField type="text"
            ref={this.inputRef}
            id={inputId}
            value={nullSafeFormattedValue}
            onChange={this.handleChangeEvent}
            onKeyDown={this.handleChangeEvent}
            disabled={disabledMode}
          />
        }
        {(editMode === false) &&
          <span>{nullSafeFormattedValue}</span>
        }
      </div>
    );
  }
}
export default InputPhoneNumberField;
